export const enum ApiErrorType {
  MaintenanceMode = 'MaintenanceMode',
  NotAuthorizedException = 'NotAuthorizedException',
  UserNotFoundException = 'UserNotFoundException'
}

export const PASSWORD_ATTEMPTS_EXCEEDED_MESSAGE = 'Password attempts exceeded'
